var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOurPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.802 13.497C35.161 12.063 36 10.131 36 8C36 3.582 32.418 0 28 0C23.582 0 20 3.582 20 8C20 10.131 20.839 12.063 22.198 13.497C21.236 14.029 20.356 14.689 19.579 15.454C18.515 12.286 15.527 10 12 10C7.582 10 4 13.582 4 18C4 20.131 4.839 22.063 6.198 23.497C2.503 25.542 0 29.476 0 34H24C24 29.823 21.866 26.149 18.63 24H40C40 19.476 37.497 15.542 33.802 13.497ZM24 8C24 5.794 25.794 4 28 4C30.206 4 32 5.794 32 8C32 10.206 30.206 12 28 12C25.794 12 24 10.206 24 8ZM8 18C8 15.794 9.794 14 12 14C14.206 14 16 15.794 16 18C16 20.206 14.206 22 12 22C9.794 22 8 20.206 8 18ZM5.074 30C6.459 27.61 9.045 26 12 26C14.955 26 17.541 27.61 18.926 30H5.074ZM21.074 20C22.459 17.61 25.045 16 28 16C30.955 16 33.541 17.61 34.926 20H21.074Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurPartner);
export default __webpack_public_path__ + "static/media/OurPartner.d95803f49b2b3fd2a1a26845ed81e7cf.svg";
export { ForwardRef as ReactComponent };